// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-aV-gl {\n  color: #272c40;\n  font-family: Open Sans Eas, Helvetica, Arial, sans-serif;\n  border: 2px solid transparent;\n  cursor: pointer;\n  box-sizing: border-box;\n  background-color: transparent;\n  border-radius: 4px;\n  font-size: 15px;\n  font-weight: 500;\n  height: 34px;\n  line-height: 26px;\n  padding: 2px 5px;\n  position: relative;\n}\n.button-aV-gl:disabled, .button-aV-gl.disabled-BhU37 {\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n.button-aV-gl.disabled-BhU37 {\n  cursor: default;\n}\n.button-aV-gl:focus {\n  background-color: #e9e9e9;\n}\n.button-aV-gl.disabled-BhU37:focus {\n  background-color: transparent;\n}\n.button-aV-gl:hover {\n  background-color: #e9e9e9;\n}\n.button-aV-gl.disabled-BhU37:hover {\n  background-color: transparent;\n}\n.button-aV-gl:active {\n  background-color: #e9e9e9;\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.button-aV-gl.disabled-BhU37:active {\n  background-color: transparent;\n  box-shadow: none;\n}\n.button-aV-gl .fa-plus-square-QniEQ {\n  font-size: 25px;\n  top: -1px;\n}\n.button-aV-gl .default-hWS0I {\n  color: #287ec7;\n}\n.button-aV-gl .icon-5ql6l {\n  display: inline-block;\n  position: relative;\n  font-weight: 500;\n  height: 21px;\n  width: 20px;\n  vertical-align: text-top;\n  margin-right: 9px;\n  font-size: 20px;\n  top: 0;\n}\n.button-aV-gl .alignIcon-XQ1P8 {\n  margin-right: 10px;\n}\nbutton.filled-jvAAH {\n  height: 34px;\n  line-height: inherit;\n  padding: 3px 15px;\n  border-radius: 4px;\n  border: 2px solid #cf4444;\n  background-color: #cf4444;\n  color: #fff;\n  font-weight: bold;\n}\nbutton.filled-jvAAH.disabled-BhU37 {\n  color: #757575;\n  background: #e1e1e1;\n  border-color: #9b9b9b;\n}\nbutton.filled-jvAAH:hover {\n  background-color: #c60000;\n  border-color: #c60000;\n  color: #fff;\n}\na.button-aV-gl {\n  display: inline-block;\n  text-decoration: none;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/buttons/toolbar-button/index.less"],"names":[],"mappings":"AAIA;EAEI,cAAA;EACA,wDAAA;EACA,6BAAA;EACA,eAAA;EACA,sBAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAyHJ;AAvHI;EAEE,UAAA;EACA,0BAAA;AAyHN;AAtHI;EACE,eAAA;AAwHN;AArHI;EACE,yBAAA;AAuHN;AApHI;EACE,6BAAA;AAsHN;AAnHI;EACE,yBAAA;AAqHN;AAlHI;EACE,6BAAA;AAoHN;AAjHI;EACE,yBAAA;EACA,gDAAA;AAmHN;AAhHI;EACE,6BAAA;EACA,gBAAA;AAkHN;AApKA;EAsDM,eAAA;EACA,SAAA;AAiHN;AAxKA;EA0DM,cAAA;AAiHN;AA3KA;EAoEM,qBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,MAAA;AAyGN;AAtLA;EAiFM,kBAAA;AAwGN;AAzLA;EAsFI,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;AAsGJ;AApGI;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AAsGN;AApGI;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AAsGN;AA7MA;EA4GI,qBAAA;EACA,qBAAA;AAoGJ","sourcesContent":["@import '@cirrus/legacy/app-components/app/styles/font-size-variables.less';\n@import '@cirrus/legacy/app-components/app/styles/typography-variables';\n@import '../variables';\n\n:local {\n  .button {\n    color: @button-default-color;\n    font-family: @eas-base-font-family;\n    border: 2px solid transparent;\n    cursor: pointer;\n    box-sizing: border-box;\n\n    background-color: transparent;\n    border-radius: 4px;\n    font-size: 15px;\n    font-weight: 500;\n    height: 34px;\n    line-height: 26px;\n    padding: 2px 5px;\n    position: relative;\n\n    &:disabled,\n    &.disabled {\n      opacity: 1;\n      filter: alpha(opacity=100);\n    }\n\n    &.disabled {\n      cursor: default;\n    }\n\n    &:focus {\n      background-color: @button-toolbar-hover-bg-color;\n    }\n\n    &.disabled:focus {\n      background-color: transparent;\n    }\n\n    &:hover {\n      background-color: @button-toolbar-hover-bg-color;\n    }\n\n    &.disabled:hover {\n      background-color: transparent;\n    }\n\n    &:active {\n      background-color: @button-toolbar-hover-bg-color;\n      box-shadow: @button-box-shadow;\n    }\n\n    &.disabled:active {\n      background-color: transparent;\n      box-shadow: none;\n    }\n\n    .fa-plus-square {\n      font-size: 25px;\n      top: -1px;\n    }\n    .default {\n      color: @button-toolbar-icon-color;\n    }\n\n    .success {\n    }\n\n    .error {\n    }\n\n    .icon {\n      display: inline-block;\n      position: relative;\n      font-weight: 500;\n\n      height: 21px;\n      width: 20px;\n      vertical-align: text-top;\n      margin-right: 9px;\n      font-size: 20px;\n      top: 0;\n    }\n\n    .alignIcon {\n      margin-right: 10px;\n    }\n  }\n\n  button.filled {\n    height: 34px;\n    line-height: inherit;\n    padding: 3px 15px;\n    border-radius: 4px;\n    border: 2px solid @clr-red-905;\n    background-color: @clr-red-905;\n    color: @clr-white;\n    font-weight: bold;\n\n    &.disabled {\n      color: @clr-gray-305;\n      background: @clr-gray-206;\n      border-color: @clr-gray-860;\n    }\n    &:hover {\n      background-color: @clr-red-910;\n      border-color: @clr-red-910;\n      color: @clr-white;\n    }\n  }\n\n  a.button {\n    display: inline-block;\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitleFontSize": "22px",
	"pageTitleLineHeight": "55px",
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"buttonDefaultColor": "#272c40",
	"buttonDefault2Color": "#ccd0d3",
	"buttonBoxShadow": "inset 0 3px 5px rgba(0, 0, 0, 0.125)",
	"buttonFilledColor": "#fff",
	"buttonSuccessColor": "#008859",
	"buttonErrorColor": "#f35958",
	"buttonLinkColor": "#554854",
	"buttonToolbarColor": "#000",
	"button": "button-aV-gl",
	"disabled": "disabled-BhU37",
	"faPlusSquare": "fa-plus-square-QniEQ",
	"default": "default-hWS0I",
	"icon": "icon-5ql6l",
	"alignIcon": "alignIcon-XQ1P8",
	"filled": "filled-jvAAH"
};
export default ___CSS_LOADER_EXPORT___;
